module.exports = __webpack_public_path__ + "img/1.1106a6c6.png";